'use client';

import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import Button from '@mui/material/Button';
import QuizQuestion from '@/components/wenhua/QuizQuestion';
import { CULTURAL_QUIZ_ID } from '@/constants/component-id';
import { CULTURE_PREFERENCE_TEXT } from '@/constants/profile-builder';
import {
  CULTURAL_RESULT_ROUTER_PATH,
  LOGIN_ROUTER_PATH,
} from '@/constants/router-path';
import { QUERY_REDIRECT } from '@/constants/auth';
import { useGsapContextSafe } from '@/utils/hooks/useGsapScroll';
import { useBodyClassName } from '@/utils/hooks/useBodyClassName';
import { useClintMediaQuery } from '@/utils/hooks/useClintMediaQuery';
import { trackClickEvent } from '@/utils/site-track';
import BackgroundImage from '@/assets/cultural/bg.png';
import ResultAImage from '@/assets/cultural/result-a.png';
import QuizImage from '@/assets/cultural/quiz.png';

const CulturalPage = () => {
  const router = useRouter();
  const isMobile = useClintMediaQuery();

  const handleSave = () => {
    router.push(
      `${LOGIN_ROUTER_PATH}?${QUERY_REDIRECT}=${CULTURAL_RESULT_ROUTER_PATH}`,
    );
  };

  const scrollToQuestion = useGsapContextSafe();

  useBodyClassName('bg-slate-50');

  return (
    <>
      <div
        className="bg-cyan-100/50"
        data-ele-id="content"
        data-ele-group="landing_免费的职场团队文化测试"
        data-observer-id="landing_免费的职场团队文化测试"
      >
        <div className="px-3 py-15 relative tablet:w-[1440px] tablet:pl-[230px] tablet:pt-[106px] tablet:pb-[177px] tablet:mx-auto">
          {!isMobile && (
            <div
              className="absolute inset-0 hidden tablet:block"
              style={{
                background: `url(${BackgroundImage.src}) no-repeat calc(50% + 18px) calc(50% + 28px)/contain`,
              }}
            />
          )}
          <p className="text-[2.375rem] leading-14 font-semibold text-center mb-4 tablet:text-[4rem] tablet:leading-[6rem] tablet:text-left">
            免费的职场团队文化测试
          </p>
          <p className="text-base leading-7 text-center mb-8 tablet:max-w-[500px] tablet:text-xl tablet:leading-8 tablet:text-left">
            带你认识市场存在的四类团队文化，找到你契合的团队文化，作为你职场上的指南针
          </p>
          <Button
            variant="contained"
            onClick={(e) => {
              trackClickEvent(e);
              scrollToQuestion({ scrollId: CULTURAL_QUIZ_ID });
            }}
            data-ele-group="landing_免费的职场团队文化测试"
            data-ele-id="culture-quiz"
            className="!block w-[350px] h-15 !text-base !mx-auto tablet:w-[376px] tablet:!mx-0"
          >
            开始测试
          </Button>
          {isMobile && (
            <div className="relative w-[273px] h-[277px] mt-10 mx-auto tablet:hidden">
              <Image
                src={ResultAImage}
                alt=""
                fill
                style={{
                  objectFit: 'contain',
                }}
              />
            </div>
          )}
        </div>
      </div>
      <div
        className="bg-white px-3 tablet:px-0"
        data-ele-id="content"
        data-ele-group="landing_理论基础-CVF竞争价值框架"
        data-observer-id="landing_理论基础-CVF竞争价值框架"
      >
        <div className="mx-auto w-full py-10 flex items-center flex-col tablet:w-[1056px] tablet:py-28 tablet:flex-row">
          <div className="tablet:max-w-[476px] tablet:mr-40">
            <p className="text-xl text-center font-semibold mb-6 tablet:text-2.75xl tablet:mb-[33px] tablet:text-left">
              理论基础-CVF竞争价值框架
            </p>
            <p className="text-base leading-8 tablet:leading-6">
              以罗伯特·E·奎因和约翰·罗尔博开发的竞争价值框架为理论原型，以组织方式和业务类型两维度划分为不同的团队，据此发展出的一套完整的文化偏好模型。
            </p>
            <p className="text-base leading-8 tablet:leading-6">
              以完整准确的模型和个人行为与组织类型的界定为依据，成为HR筛选团队成员，人才选择企业的有效判定标准。
            </p>
          </div>
          <div className="relative w-[315px] h-[140px] mt-5 tablet:w-[420px] tablet:h-[186px] tablet:mt-0">
            <Image
              src={QuizImage}
              alt=""
              fill
              style={{
                objectFit: 'contain',
              }}
            />
          </div>
        </div>
      </div>
      <div
        className="bg-slate-50 h-[300vh]"
        id={CULTURAL_QUIZ_ID}
        data-ele-id="content"
        data-ele-group="landing_quiz"
        data-observer-id="landing_quiz"
      >
        <div className="px-3 pt-16 sticky top-4 tablet:px-0 tablet:pt-28">
          <QuizQuestion
            handleSave={handleSave}
            needToStorage={true}
            culturePreferenceText={CULTURE_PREFERENCE_TEXT}
            dataEleGroup="landing_quiz"
          />
        </div>
      </div>
    </>
  );
};

export default CulturalPage;
